import { render } from "./CardTags.vue?vue&type=template&id=1e1c0289"
import script from "./CardTags.vue?vue&type=script&lang=js"
export * from "./CardTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__